import styles from './loading.module.css';

const Loading = () => {
  return (
    <div class="spinner" className={styles.spinner}/>
  );
};
export default Loading;
